import { InputPhoneNumber, Link, Button } from "components/core";
import { Row, Col } from "react-flexbox-grid";
import { phoneRegExp } from "constants/index";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import styled from "pages/public/Login/Login.module.css";

const SchemaSignIn = yup.object().shape({
  phoneNumber: yup
    .string()
    .length(10, "El número de teléfono debe tener 10 caracteres")
    .matches(phoneRegExp, "El número de teléfono no es válido"),
});

export const FormSignIn = ({ setNumber, sendStepLogin, isLoading }) => {
  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(SchemaSignIn),
  });

  const onSubmit = ({ phoneNumber }) => {
    setNumber(phoneNumber);
  };

  return (
    <Row className={styled.footer}>
      <Col xs={12}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputPhoneNumber
            type="number"
            name="phoneNumber"
            ref={register}
            placeholder="Número de telefono"
            helperText={errors.phoneNumber?.message}
          />
          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              loading={isLoading}
            >
              Continuar
            </Button>
          </Col>

          <Row center="xs">
            <Col md={12} className="mt2">
              <Link
                isNotLink
                to={null}
                className="text-center"
                onClick={sendStepLogin}
              >
                ¿Ya tienes cuenta?
              </Link>
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
};
